<nb-card *ngIf="entity">
  <nb-card-body>
    <div>
      <strong>{{'Devices' | translate}}: </strong>{{(subscribers$ | async)?.devices}}
    </div>
    <div>
      <strong>Name: </strong>{{entity.name}}
    </div>
    <div>
      <strong>Id: </strong>{{entity.id}}
    </div>
    <div *ngIf="entity.sourceId">
      <strong>Source Id: </strong>{{entity.sourceId}}
    </div>
  </nb-card-body>
</nb-card>
